import {
    LENTCAR_FETCHING,
    LENTCAR_FAILED,
    LENTCAR_SUCCESS,
} from "../actions/types";

const initialState = {
    result: null,
    isFetching: false,
    isError: false,
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case LENTCAR_FETCHING:
            return { ...state, result: null, isFetching: true, isError: false };    
        case LENTCAR_FAILED:
            return { ...state, result: null, isFetching: false, isError: true };
        case LENTCAR_SUCCESS:
            return { ...state, result: payload, isFetching: false, isError: false};
        default:
            return state;
    }
}